// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Grid from "../layout-and-structure/Grid.res.js";
import * as Group from "../layout-and-structure/Group.res.js";
import * as Hover from "../../primitives/Hover.res.js";
import * as React from "react";
import * as Tooltip from "../overlays/Tooltip.res.js";
import * as ReactAria from "react-aria";
import * as TooltipIcon from "../overlays/TooltipIcon.res.js";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";
import * as ReactStately from "react-stately";
import * as Stdlib_Nullable from "@rescript/runtime/lib/es6/Stdlib_Nullable.js";
import * as Stylex from "@stylexjs/stylex";
import * as Primitive_option from "@rescript/runtime/lib/es6/Primitive_option.js";
import * as JsxRuntime from "react/jsx-runtime";
let styles = {
  RadioCardItem_RadioButton_root: {
    "backgroundColor-kWkggS": "backgroundColor-x12peec7",
    "borderRadius-kaIpWk": "borderRadius-x16rqkct",
    "outline-kI3sdo": "outline-x145y8nr",
    "transition-kmkexE": "transition-x1d26w49",
    "height-kZKoxP": "height-xlup9mm",
    "minWidth-k7Eaqz": "minWidth-x15kz4h8",
    "width-kzqmXN": "width-x1kky2od",
    $$css: "wino-gc:src/resources/selection-and-input/RadioCardGroup.res.js:18"
  }
};
function styleProps(selected, disabled, hovered, pressed) {
  let tmp;
  let exit = 0;
  if (selected) {
    if (disabled) {
      exit = 1;
    } else {
      tmp = {
        outlineOffset: "-5.5px",
        outlineWidth: "5px"
      };
    }
  } else if (pressed && !disabled) {
    tmp = {
      outlineOffset: "-3.5px",
      outlineWidth: "3px"
    };
  } else {
    exit = 1;
  }
  if (exit === 1) {
    tmp = {
      outlineOffset: "-2.5px",
      outlineWidth: "1.5px"
    };
  }
  return Stylex.props(styles.RadioCardItem_RadioButton_root, tmp, {
    outlineColor: disabled ? "#d7d7e0" : selected ? "#a01e72" : hovered ? "#8a0262" : "#a2a1b0"
  }, {
    transition: selected ? "outline-width .045s cubic-bezier(0, 0, 0, 1)" : "none"
  }, {
    backgroundColor: disabled ? "#f8f8fb" : "white"
  });
}
let make = React.memo(props => {
  let match = styleProps(props.selected, props.disabled, props.hovered, props.pressed);
  return JsxRuntime.jsx("div", {
    className: match.className,
    style: match.style
  });
});
let styles$1 = {
  RadioCardItem_root: {
    "boxSizing-kB7OPa": "boxSizing-x9f619",
    "borderRadius-kaIpWk": "borderRadius-x1sxf85j",
    "outline-kI3sdo": "outline-x145y8nr",
    "transition-kmkexE": "transition-x7enndm",
    "boxShadow-kGVxlE": "boxShadow-xn9h25f",
    "flex-kUk6DE": "flex-x98rzlu",
    "padding-kmVPX3": "padding-x1dypa6k",
    $$css: "wino-gc:src/resources/selection-and-input/RadioCardGroup.res.js:77"
  },
  RadioCardItem_title: {
    "fontFamily-kMv6JI": "fontFamily-xoy7umi",
    "fontSize-kGuDYH": "fontSize-x1j61zf2",
    "lineHeight-kLWn49": "lineHeight-x1d3mw78",
    "whiteSpace-khDVqt": "whiteSpace-xuxw1ft",
    "wordBreak-kTgw9": "wordBreak-x1lldw8n",
    "flexGrow-kzQI83": "flexGrow-x1iyjqo2",
    $$css: "wino-gc:src/resources/selection-and-input/RadioCardGroup.res.js:122"
  },
  RadioCardItem_description: {
    "fontFamily-kMv6JI": "fontFamily-x1rf0u83",
    "fontSize-kGuDYH": "fontSize-xfifm61",
    "fontWeight-k63SB2": "fontWeight-xo1l8bm",
    "lineHeight-kLWn49": "lineHeight-x1xxsxie",
    $$css: "wino-gc:src/resources/selection-and-input/RadioCardGroup.res.js:130"
  }
};
function styleProps$1(selected, disabled, hovered, pressed) {
  let tmp;
  let exit = 0;
  exit = selected ? pressed || disabled ? 1 : 2 : pressed && !disabled ? 2 : 1;
  switch (exit) {
    case 1:
      tmp = {
        outlineOffset: "-1.5px",
        outlineWidth: "1.5px"
      };
      break;
    case 2:
      tmp = {
        outlineOffset: "-2px",
        outlineWidth: "2px"
      };
      break;
  }
  return Stylex.props(styles$1.RadioCardItem_root, tmp, {
    outlineColor: disabled ? "#D7D7E0" : selected || hovered ? "#A01E72" : "#A2A1B0"
  }, {
    backgroundColor: disabled ? "#f8f8fb" : "white"
  });
}
function titleStyleProps(disabled, bold) {
  return Stylex.props(styles$1.RadioCardItem_title, {
    fontWeight: bold ? 700 : 400
  }, {
    color: disabled ? "#8c8B9b" : "#25243a"
  });
}
function descriptionStyleProps(disabled) {
  return Stylex.props(styles$1.RadioCardItem_description, {
    color: disabled ? "#8c8B9b" : "#25243a"
  });
}
let make$1 = React.memo(props => {
  let __disabled = props.disabled;
  let selected = props.selected;
  let endElement = props.endElement;
  let illustrationSvg = props.illustrationSvg;
  let description = props.description;
  let tooltip = props.tooltip;
  let disabled = __disabled !== undefined ? __disabled : false;
  let match = Hover.use(undefined, undefined, undefined);
  let hovered = match[1];
  let match$1 = ReactAria.usePress({
    allowTextSelectionOnPress: false
  });
  let pressed = match$1.isPressed;
  let inputDomRef = React.useRef(null);
  let match$2 = styleProps$1(selected, disabled, hovered, pressed);
  let match$3 = {
    className: "alignItems-x1qjc9v5 display-x78zum5 flexDirection-x1q0g3np gap-x883omv",
    "data-style-src": "wino-gc:src/resources/selection-and-input/RadioCardGroup.res.js:86"
  };
  let match$4 = {
    className: "borderBottomRightRadius-x1w61mk2 borderTopRightRadius-xbjeahn alignItems-x1qjc9v5 alignSelf-xkh2ocl display-x78zum5 flexShrink-x2lah0s marginBlock-x1t0yant marginRight-x8lkd overflow-xb3r6kr",
    "data-style-src": "wino-gc:src/resources/selection-and-input/RadioCardGroup.res.js:92"
  };
  let match$5 = {
    className: "display-x78zum5 flex-x98rzlu flexDirection-xdt5ytf gap-x17d4w8g",
    "data-style-src": "wino-gc:src/resources/selection-and-input/RadioCardGroup.res.js:103"
  };
  let match$6 = {
    className: "columnGap-xfex06f display-x78zum5 flex-x98rzlu flexDirection-x1q0g3np flexWrap-x1a02dak justifyContent-x1qughib minWidth-x13qp9f6 rowGap-x1r0jzty",
    "data-style-src": "wino-gc:src/resources/selection-and-input/RadioCardGroup.res.js:109"
  };
  let match$7 = {
    className: "alignSelf-xamitd3",
    "data-style-src": "wino-gc:src/resources/selection-and-input/RadioCardGroup.res.js:119"
  };
  let match$8 = titleStyleProps(disabled, selected || Stdlib_Option.isSome(description));
  let match$9 = descriptionStyleProps(disabled);
  let children = JsxRuntime.jsxs("div", {
    children: [JsxRuntime.jsx(make, {
      selected: selected,
      disabled: disabled,
      hovered: hovered,
      pressed: pressed
    }), JsxRuntime.jsxs("div", {
      children: [JsxRuntime.jsxs("div", {
        children: [JsxRuntime.jsx("span", {
          children: props.title,
          className: match$8.className,
          style: match$8.style
        }), tooltip !== undefined ? JsxRuntime.jsx(TooltipIcon.make, {
          children: JsxRuntime.jsx(Tooltip.Span.make, {
            text: tooltip
          })
        }) : null, endElement !== undefined ? JsxRuntime.jsx("div", {
          children: endElement,
          className: match$7.className
        }) : null],
        className: match$6.className
      }), description !== undefined ? JsxRuntime.jsx("div", {
        children: description,
        className: match$9.className,
        style: match$9.style
      }) : null],
      className: match$5.className
    }), illustrationSvg !== undefined ? JsxRuntime.jsx("div", {
      children: illustrationSvg,
      className: match$4.className
    }) : null],
    className: match$3.className
  });
  let props_value = props.value;
  let props_isDisabled = disabled;
  let props$1 = {
    value: props_value,
    children: children,
    isDisabled: props_isDisabled
  };
  let match$10 = ReactAria.useRadio(props$1, props.groupState, inputDomRef);
  let newrecord = {
    ...match$1.pressProps
  };
  newrecord.style = match$2.style;
  newrecord.className = match$2.className;
  newrecord.ref = Primitive_option.some(match[0]);
  let newrecord$1 = {
    ...match$10.inputProps
  };
  newrecord.children = [JsxRuntime.jsx(ReactAria.VisuallyHidden, {
    children: JsxRuntime.jsx("input", (newrecord$1.ref = Primitive_option.some(inputDomRef), newrecord$1))
  }), children];
  return JsxRuntime.jsxs("label", newrecord);
});
function RadioCardGroup(props) {
  let __disabled = props.disabled;
  let value = props.value;
  let items = props.items;
  let __orientation = props.orientation;
  let orientation = __orientation !== undefined ? __orientation : "auto";
  let disabled = __disabled !== undefined ? __disabled : false;
  let props_orientation = orientation === "vertical" ? "vertical" : "horizontal";
  let props_isDisabled = disabled;
  let props_onChange = props.onChange;
  let props$1 = {
    value: value,
    orientation: props_orientation,
    isDisabled: props_isDisabled,
    onChange: props_onChange
  };
  let state = ReactStately.useRadioGroupState(props$1);
  let match = ReactAria.useRadioGroup(props$1, state);
  React.useEffect(() => {
    if (!items.some(item => item.value === value)) {
      state.setSelectedValue(Stdlib_Nullable.fromOption(Stdlib_Option.map(items[0], item => item.value)));
    }
  }, [value, items]);
  let children = items.map(item => {
    let value = item.value;
    let disabled$1 = Stdlib_Option.getOr(item.disabled, false) || disabled;
    let selected = state.selectedValue === value;
    return JsxRuntime.jsx(make$1, {
      title: item.title,
      tooltip: item.tooltip,
      description: item.description,
      illustrationSvg: item.illustrationSvg,
      endElement: item.endElement,
      groupState: state,
      selected: selected,
      disabled: disabled$1,
      value: value
    }, value);
  });
  let newrecord = {
    ...match.radioGroupProps
  };
  return JsxRuntime.jsx("div", (newrecord.children = orientation === "vertical" ? JsxRuntime.jsx(Group.make, {
    children: children,
    grid: ["100%"],
    spaceX: "medium",
    spaceY: "medium"
  }) : orientation === "horizontal" ? JsxRuntime.jsx(Group.make, {
    children: children,
    wrap: false,
    spaceX: "medium"
  }) : JsxRuntime.jsx(Grid.make, {
    gap: "l",
    children: children
  }), newrecord));
}
let make$2 = React.memo(RadioCardGroup);
export { make$2 as make };
/* styles Not a pure module */